module.exports = __webpack_public_path__ + "img/Gimi-1024x452.f80fd113.png";